
<template>
  <div v-if="visible">
    <div
      v-if="shouldShowFlashcard"
      class=""
      v-html="flashcardTemplate"
    >
    </div>
    <template
      v-for="(item, index) in dropDowns"
    >
      <select
        v-if="!answered"
        :id="dropdownIdentifier(index)"
        :ref="dropdownIdentifier(index)"
        :key="dropdownIdentifier(index)"
        @change="handleDropdownChange(index)"
      >
        <option value="">
          -- Please Select One --
        </option>
        <option
          v-for="option in item"
          :key="option.id"
          :value="option.id"
        >
          {{ option.content }}
        </option>
      </select>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    answered: {
      type: Boolean,
    },
    answerIds: {
      type: Array,
    },
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    flashcardState: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  computed: {
    dropDowns() {
      let result = {};
      for( let answer of this.flashcard.answers ) {
        if( !result[answer.dropDownIdentifier]) {
          result[answer.dropDownIdentifier] = [];
        }
        result[answer.dropDownIdentifier].push(answer);
      }
      const keys = Object.keys(result);
      keys.forEach((key) => {
        result[key] = result[key].sort((a, b) => {
          return a.sortOrder - b.sortOrder;
        });
      });
      // ToDo: sort the answers by their order property
      return result;
    },
    numAnswers() {
      return Object.keys(this.dropDowns).length || 0;
    },
    flashcardTemplate() {
      let template = this.flashcard.question;
      if( !this.answered ) {
        this.flashcard.question.match(/\{\{[^\}]+\}\}/g).forEach( (match) => {
          const identifier = match.replace(/[\{\}\s]/g, '');
          const m = RegExp(`\{\{ *${identifier} *\}\}`);
          template = template.replace(m, `<span id="container-${identifier}"></span>`);
        });
      } else {
        this.flashcard.question.match(/\{\{[^\}]+\}\}/g).forEach( (match) => {
          const identifier = match.replace(/[\{\}\s]/g, '');
          const identifierNum = parseInt(identifier.replace(/[^0-9]/g, ''));
          const m = RegExp(`\{\{ +${identifier} +\}\}`);
          const possibleAnswers = this.flashcard.answers.filter( a => a.dropDownIdentifier === identifierNum);
          const possibleAnswerIds = possibleAnswers.map( a => parseInt(a.id));

          let searchIds;
          if(this.answerIds.length == 0) {
            searchIds = this.flashcardState.answerIds;
          } else {
            searchIds = this.answerIds;
          }
          searchIds.forEach( id => {
            id = parseInt(id);
            if (possibleAnswerIds.includes(id)) {
              const answer = possibleAnswers.find( a => parseInt(a.id) === id);
              const answerClass = answer.correct ? 'cloze-correct' : 'cloze-incorrect';
              const replacementText = `<span class="${answerClass}">${answer.content}</span>`;
              template = template.replace(m, replacementText);
            }
          });
        });
      }
      return template;
    },
    shouldShowFlashcard() {
      return true;
    },
  },
  watch: {
    async $route(to, from) {
      // this are about to get a little weird
      this.visible = false;
      await this.$nextTick();
      this.visible = true;
      await this.$nextTick();
      this.arrangeDropdowns();
    },
  },
  mounted() {
    this.$nextTick(this.arrangeDropdowns);
  },
  methods: {
    arrangeDropdowns() {
      const keys = Object.keys(this.dropDowns);
      keys.forEach((key) => {
        const dropdownIdentifier = `dropdown-${key}`;
        const containerIdentifier = `container-${dropdownIdentifier}`;
        const dropdownElement = document.getElementById(dropdownIdentifier);
        const containerElement = document.getElementById(containerIdentifier);
        if( dropdownElement && containerElement ) {
          if( dropdownElement.parentNode !== containerElement ) {
            containerElement.appendChild(dropdownElement);
          }
        }
      });
    },
    selectedAnswerIds() {
      const keys = Object.keys(this.dropDowns);
      let ids = [];
      keys.forEach((key) => {
        const dropdownIdentifier = `dropdown-${key}`;
        const dropdownElement = document.getElementById(dropdownIdentifier);
        const selectedAnswerId = dropdownElement.value;
        ids[key] = selectedAnswerId;
      });

      ids = ids.filter( id => id );
      ids = ids.map( id => parseInt(id));
      return ids;
    },
    dropdownKey(index) {
      return `${this.flashcard.id}-dropdown-${index}`;
    },
    dropdownIdentifier(index) {
      return `dropdown-${index}`;
    },
    handleDropdownChange(event) {
      const selectedIds = this.selectedAnswerIds();
      if( selectedIds.length >= this.numAnswers ) {
        this.$emit('set-answer-ids', selectedIds);
      } else {
        this.$emit('set-answer-ids', []);
      }
    },
  },
};
</script>

<style lang='scss'>
  .stem {
    line-height: 1.75;
  }
  .cloze-correct {
    white-space: nowrap !important;
    color: #000000;
    background-color: RGBA(0, 180, 109, 0.15);
    border: 1px solid #000000;
    border-radius: 4px;
    padding-left: 6px;
    padding-right: 6px;
  }
  .cloze-incorrect {
    white-space: nowrap !important;
    color: #000000;
    background-color: RGBA(220, 50, 22, 0.15);
    border: 1px solid #000000;
    border-radius: 4px;
    padding-left: 6px;
    padding-right: 6px;
  }


</style>
